/**
 * Created by dushyantha on 10/10/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name trainingSchedule.service:TrainingScheduleService
     *
     * @description
     *
     */
    angular
        .module('trainingSchedule')
        .service('TrainingScheduleService', TrainingScheduleService);
    function TrainingScheduleService(RemoteService,CrewingRequest,CrewingAdaptor,AssignExternalTraineesFactory) {
        var vm = this;
        var trainingLocation=[];
        var trainingSchedule=[];
        var trainingOriginalSchedule=[];
        var trainingCategory=[];
        var airCraftType=[];
        var trainingCrewType=[];
        var trainingProgramCodes=[];
        var trainingLocationList=[];
        var traineesList=[];
        var trainersList=[];
        var refineProgramCode=[];
        var refineCrewType=[];
        var refineTrainer=[];
        var refineTrainee=[];
        var warningColorOrange = "#FFC200";
        var warningColorRed = "#ff0000";


        vm.getDefaultTrainingLocation = function () {
            trainingLocation = [];
            trainingLocation.push({
                airPortCode:null,
                airPortName:"ANY "
            });
            return trainingLocation[0];
        };
        vm.getDefaultTrainingCategory =function (){
            trainingCategory = [];
            trainingCategory.push({
                category:"ANY",
                categoryCode:null
            });
            return trainingCategory[0];
        };
        vm.getDefaultAircraftType =function (){
            airCraftType = [];
            airCraftType.push({
                model:'ANY',
                modelNumber:null
            });
            return airCraftType[0];
        };
        vm.getAirCraftTypes = function () {
               return airCraftType;
        };
        vm.getTrainingLocations = function(){
            return trainingLocation;
        };
        vm.setAirCraftTypes = function (aircraftTypes) {
            airCraftType = [];
            airCraftType[0] = vm.getDefaultAircraftType();
            angular.forEach(aircraftTypes,function(airCraft){
                airCraftType.push({
                    model:airCraft.modelNumber.trim(),
                    modelNumber:airCraft.modelNumber.trim()
                })
            });
        };
        vm.setTrainingCategory = function (trainingCat) {
            trainingCategory=[];
            trainingCategory[0]=vm.getDefaultTrainingCategory();
            angular.forEach(trainingCat,function(training){
                trainingCategory.push({
                    category:training.categoryCode.trim(),
                    categoryCode:training.categoryCode.trim()
                })
            });

        };
        vm.getTrainingCategory = function () {
            return trainingCategory;
        };
        vm.setTrainingSchedule = function (schedule) {
            trainingSchedule = schedule;
            trainingOriginalSchedule = angular.copy(schedule);
            setTrainingLocationFormTrainingList();
            setProgramCodeFormTrainingList();
            setCrewTypeFormTrainingList();
            setTrainersFormTrainingList();
            setTraineesFormTrainingList();

        };
        function setTrainingLocationFormTrainingList() {
            trainingLocation = [];
            trainingLocation[0] = vm.getDefaultTrainingLocation();

            var sorted = _.sortBy(trainingSchedule, function(item){
                return item.trainingLocation;
            });

            var temp =  _.uniq(sorted, true, function(i){
                return i.trainingLocation;
            });
            _.each(temp, function(x){
                trainingLocation.push({
                    airPortCode: x.trainingLocation + " ",
                    airPortName: x.trainingLocation
                });
            });
        }

        /**
         * Search Crew Profile
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.searchTrainingSchedule= function(param,showLoading,successFn, errorFn) {
            if (angular.isUndefined(showLoading)) {
                showLoading = true;
            }
            this.headerParam = {'show-loading': showLoading};

            RemoteService.searchTrainingSchedule.call(this, param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );

        };

        /**
         * Search Crew Profile
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.getTrainingBySlotID= function(param,successFn, errorFn) {

            this.headerParam = {'show-loading': false};

            RemoteService.getTrainingBySlotID(param,this).then(
                function (response) {
                    successFn(response.trainingProgramDetail);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );

        };

        vm.loadTrainingProgram= function(param,successFn, errorFn) {

            RemoteService.loadTrainingProgram(param, false).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );

        };

        vm.appendToTrainingSchedule = function(currentSchedule, newSchedule){
            angular.forEach(newSchedule, function (schedule) {
                var fundScheduleIndex = _.findIndex(currentSchedule.schedule, {crewId: schedule.crewId});
                if (fundScheduleIndex >= 0) {
                    currentSchedule.splice(fundScheduleIndex, 1, schedule);
                } else {
                    schedule.id = (currentSchedule.length+1);
                    currentSchedule.push(schedule);
                }
            });
        };

        vm.adaptTrainingData= function (trainingSchedule) {
            var currentDate = moment();
            var isExpired = false;
            var isWarning = false;
            angular.forEach(trainingSchedule, function (schedule,key) {

                if(key ==0){
                    schedule.isSelected = true;
                }
                else{
                    schedule.isSelected = false;
                }
                //adding crew trainer expiries to assignedTrainer
                if(!!schedule.assignedTrainers){
                  angular.forEach(schedule.assignedTrainers, function (trainer, key){
                    trainer.expiries = schedule.assignedCrewTrainerExpiries[key].assignedCrewExpiries;
                    //setting warning color for expiries
                    if(!!trainer.expiries) {
                      isWarning = false;
                      isExpired = false;
                      angular.forEach(trainer.expiries, function (expiry, key) {
                        //set to orange color
                        if(isDay1BeforeDay2(expiry.warningDate,currentDate )){
                          isWarning = true;
                          expiry.backGroundColor = warningColorOrange;
                          //set to red color
                          if(isDay1BeforeDay2(expiry.dateOfExpiry, currentDate)){
                            isExpired = true;
                            expiry.backGroundColor = warningColorRed;
                          }
                        }
                      });
                      if(isWarning) trainer.backGroundColor = warningColorOrange;
                        if(isExpired) trainer.backGroundColor = warningColorRed;
                    }
                  });
                }
                schedule.id = (key+1);

            });
            return trainingSchedule;
        };
      function isDay1BeforeDay2(day1, day2) {
        return moment(day1).isBefore(moment(day2));
      }
        vm.adaptSelectedTraining = function (scheule) {
            if(!!scheule && !!scheule.assignedTraineeDetail){
            	angular.forEach(scheule.assignedTraineeDetail, function (crewCategory) {
                    angular.forEach(crewCategory.allocatedCrewList, function (crew) {
                        crew.isSelected = false;
                    });
                });
            }
            if(!!scheule && !!scheule.assignedTrainerDetail){
            	angular.forEach(scheule.assignedTrainerDetail, function (trainerCategory) {
                    angular.forEach(trainerCategory.allocatedCrewList, function (crew) {
                        crew.isSelected = false;
                    });
                });
            }
            return scheule;
        };

        vm.adaptTrainingProgram =function(trainingProgram){
            angular.forEach(trainingProgram, function (training) {

                training.isSelected = false;
            });
            return trainingProgram;
        };

        vm.getAssignedList = function (programDetails,selectedItem) {
            var temp=[];
            var selectedPro = _.find(programDetails,{trainingProgramDetailId:selectedItem.trainingProgramDetailId})
            temp.push(selectedPro);
            return temp;
        };
        vm.adaptProgramList = function(assignedPrograms,programDetails) {
            angular.forEach(assignedPrograms, function (program) {
                var index = programDetails.indexOf(program);
                if (index > -1) {
                    programDetails.splice(index, 1);
                }
            });
            return programDetails;
        };
        vm.refineTrainingData = function (refineParam) {
          const filter = {
            airCraftType:refineParam.aircraftModelDetails.airCraftType&&refineParam.aircraftModelDetails.airCraftType.trim(),
            trainingLocation:refineParam.selectedTrainingLocation.airPortCode&&refineParam.selectedTrainingLocation.airPortCode.trim(),
            trainingProgCategory:refineParam.trainingProCategoryDetails.categoryCode&&refineParam.trainingProCategoryDetails.categoryCode.trim(),
            trainingProgram:refineParam.selectedProgramCode.programCode&&refineParam.selectedProgramCode.programCode.trim()
          };

          const filterTrainees={
            assignedTrainees:refineParam.selectedTrainee.crewName&&refineParam.selectedTrainee.crewName.trim()
          }

          const filterTrainers={
            assignedTrainers:refineParam.selectedTrainer.crewName&&refineParam.selectedTrainer.crewName.trim()
          }

          const filterCrewType={
            crewType:refineParam.selectedCrewType.crewTypeCode&&refineParam.selectedCrewType.crewTypeCode.trim()
          }

          const keyArray=Object.keys(filter);
          const  filteredSchedule=trainingOriginalSchedule.filter(function (item) {
             for(let i=0;i<keyArray.length;i++){
               let key=keyArray[i];
               if(filter[key]) {
                 if (item[key] === undefined || item[key] !== filter[key]) {
                   return false;
                 }
               }
             }
            return true;
          });


          const keyArrayFilterTrainee=Object.keys(filterTrainees);

          const filterByTrainee=filteredSchedule.filter(function(item){

            for(let i=0;i<keyArrayFilterTrainee.length;i++){
              let key=keyArrayFilterTrainee[i];
              if(filterTrainees[key]) {
                if(item[key]) {
                  return item[key].some(function (i) {
                    if (i.crewName.trim() !== filterTrainees[key]) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                }
               return false;
              }
            }
            return true;
          })

          const keyArrayFilterTrainer=Object.keys(filterTrainers);

          let filterByTrainer=filterByTrainee.filter(function(item){

            for(let i=0;i<keyArrayFilterTrainer.length;i++){
              let key=keyArrayFilterTrainer[i];
              if(filterTrainers[key]) {
                if(item[key]) {
                  return item[key].some(function (i) {
                    if (i.crewName.trim() !== filterTrainers[key]) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                }
                return false;
              }
            }
            return true;
          })

          const keyArrayFilterCrewType=Object.keys(filterCrewType);

          let resultAfterFiltering=filterByTrainer.filter(function(item){
            for(let i=0;i<keyArrayFilterCrewType.length;i++){
              let key=keyArrayFilterCrewType[i];
              if(filterCrewType[key]) {

                let resultTrainees=false;
                let resultTrainers=false;

                if(item.assignedTrainees) {
                  resultTrainees= item.assignedTrainees.some(function(i){
                    if(i.crewType.trim()!==filterCrewType[key]){
                      return false;
                    }else{
                      return true;
                    }

                  })
                }

                if(item.assignedTrainers){
                  resultTrainers= item.assignedTrainers.some(function(i){
                    if(i.crewType.trim()!==filterCrewType[key]){
                      return false;
                    }else{
                      return true;
                    }

                  })
                }
                return resultTrainees||resultTrainers;
              }



            }
            return true;

          });

          return resultAfterFiltering;
        };

        /**
         * Update Training Program
         * @param request
         * @param successFn
         * @param errorFn
         */
        vm.updateTrainingProgram = function (request, successFn, errorFn) {
            RemoteService.updateTrainingSchedule(request,true).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error)
                }
            );
        };

        /**
         * Search Trainer types
         * @param successFn
         * @param errorFn
         */
        vm.getTrainerTypes = function(successFn, errorFn) {

            RemoteService.getTrainerTypes().then(
                function (response) {
                    successFn(response.trainerTypeList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );

        };

        vm.searchCrewList =function(param,successFn, errorFn) {

            RemoteService.getCrewList(param,true).then(
                function (response) {
                    successFn(response.scheduleCrewData);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );

        };
        /**
         * Assign Trainer Trainee
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.assignTrainerTrainee= function (param,successFn, errorFn) {
            RemoteService.assignTrainerTrainee(param,true).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        /**
         * Assign Trainer Trainee
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.unAssignTrainerTrainee= function (param,successFn, errorFn) {
            RemoteService.unAssignTrainerTrainee(param,true).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        /**
         * Assign External Trainee
         * @param param
         * @param successFn
         * @param errorFn
         */

        vm.unAssignExternalTrainee = function (param,successFn, errorFn) {
            RemoteService.unAssignExternalTrainee(param,true).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
         };

        /**
         * Un - Assign Trainer Trainee
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.unAssignTrainerTrainee = function (param, successFn, errorFn) {

            RemoteService.unAssignBlock(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        vm.loadTrainingProgramDetails = function (param, successFn, errorFn) {
            RemoteService.loadTrainingProgramDetails(param.trainingProgramId).then(
                function (response) {
                    if (response.success) {
                        if (response.hasOwnProperty('trainingProgDetailDTOs')) {
                            self.model.trainingPrograms[program.trainingProgramId] = response.trainingProgDetailDTOs;
                            successFn(self.model.trainingPrograms[program.trainingProgramId]);
                        }
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        }

        vm.addExternalTrainees = function (externalTraineeList, successFn, errorFn) {
        	var postData = AssignExternalTraineesFactory.populateExternalTraineeSaveRequest(externalTraineeList);
        	RemoteService.assignExternalTrainee(postData).then(
               function (response) {
                  successFn(response);
               },
               function (error) {
                  errorFn(error);
               });
        }


      vm.getDefaultTrainingCrewTypes = function () {
        trainingCrewType=[];
        trainingCrewType.push({
          crewType:'ANY',
          crewTypeCode:null
        });
        return trainingCrewType[0];
      }
      vm.setTrainingCrewTypes=function (trainingCrewTypes) {
        trainingCrewType=[];
        trainingCrewType[0]=vm.getDefaultTrainingCrewTypes();
        angular.forEach(trainingCrewTypes,function (crewType) {
        trainingCrewType.push({
          crewType:crewType.crewTypeDescription.trim(),
          crewTypeCode:crewType.crewTypeCode.trim()
           })
        });
      }
      vm.getTrainingCrewTypes = function(){
        return trainingCrewType;
      }

      vm.getDefaultTrainingProgramCodes = function () {
        trainingProgramCodes=[];
        trainingProgramCodes.push({
          program:'ANY',
          programCode:null
        });
        return trainingProgramCodes[0];
      }
      vm.setTrainingProgramCodes=function (trainingProgramCode) {
        trainingProgramCodes=[];
        trainingProgramCodes[0]=vm.getDefaultTrainingProgramCodes();
        angular.forEach(trainingProgramCode,function (programCodes) {
          trainingProgramCodes.push({
            program:programCodes.trainingProgramCode.trim(),
            programCode:programCodes.trainingProgramCode.trim()
          })
        });
      }
      vm.getTrainingProgramCodes = function(){
        return trainingProgramCodes;
      }


      vm.getDefaultTrainingLocationList = function () {
        trainingLocationList=[];
        trainingLocationList.push({
          location:'ANY',
          locationCode:null
        });
        return trainingLocationList[0];
      }
      vm.setTrainingLocationList=function (trainingLocation) {
        trainingLocationList=[];
        trainingLocationList[0]=vm.getDefaultTrainingLocationList();
        angular.forEach(trainingLocation,function (location) {
          trainingLocationList.push({
            location:location.trainingLocationDesc.trim(),
            locationCode:location.trainingLocationCode.trim()
          })
        });
      }
      vm.getTrainingLocationList= function(){
        return trainingLocationList;
      }

      vm.getDefaultTraineesList = function () {
        traineesList=[];
        traineesList.push({
          crewId:null,
          crewName:null
        });
        return traineesList[0];
      }
      vm.setTraineesList=function (trainees) {
        traineesList=[];
        traineesList[0]=vm.getDefaultTraineesList();
        angular.forEach(trainees,function (trainee) {
          traineesList.push({
            crewId:trainee.crewId.trim(),
            crewName:trainee.name.trim()
          })
        });
      }
      vm.getTraineesList= function(){
        return traineesList;
      }


      vm.getDefaultTrainersList = function () {
        trainersList=[];
        trainersList.push({
          crewId:null,
          crewName:null
        });
        return trainersList[0];
      }
      vm.setTrainersList=function (trainees) {
        trainersList=[];
        trainersList[0]=vm.getDefaultTrainersList();
        angular.forEach(trainees,function (trainee) {
          trainersList.push({
            crewId:trainee.crewId.trim(),
            crewName:trainee.name.trim()
          })
        });
      }
      vm.getTrainersList= function(){
        return trainersList;
      }


      vm.getDefaultRefineTrainingProgramCodes = function () {
        refineProgramCode=[];
        refineProgramCode.push({
          program:'ANY',
          programCode:null
        });
        return refineProgramCode[0];
      }


      function setProgramCodeFormTrainingList() {
        refineProgramCode = [];
        refineProgramCode[0] = vm.getDefaultRefineTrainingProgramCodes();

        var sorted = _.sortBy(trainingSchedule, function(item){
          return item.trainingProgram;
        });


        var temp =  _.uniq(sorted, true, function(i){
          return i.trainingProgram;
        });

        _.each(temp, function(x){
          if(x.trainingProgram) {
            refineProgramCode.push({
              program: x.trainingProgram,
              programCode: x.trainingProgram
            });
          }
        });


      }

      vm.getRefineProgramCodes = function(){
        return refineProgramCode;
      };



      vm.getDefaultRefineCrewType = function () {
        refineCrewType=[];
        refineCrewType.push({
          crewType:'ANY',
          crewTypeCode:null
        });
        return refineCrewType[0];
      }


      function setCrewTypeFormTrainingList() {
        refineCrewType = [];
        refineCrewType[0] = vm.getDefaultRefineCrewType();

        let crewType=[];
        _.each(trainingSchedule,function (item) {
          if(item.assignedTrainees&&item.assignedTrainees.length>0){
            let trainees=item.assignedTrainees;
            for(let i=0;i<trainees.length;i++){
              crewType.push(trainees[i].crewType);
            }
          }
        })
        _.each(trainingSchedule,function (item) {
          if(item.assignedTrainers&&item.assignedTrainers.length>0){
            let trainees=item.assignedTrainers;
            for(let i=0;i<trainees.length;i++){
              crewType.push(trainees[i].crewType);
            }
          }
        })

        var sorted = _.sortBy(crewType, function(item){
             return item;
        });


        var temp =  _.uniq(sorted, true, function(i){
          return i;
        });

        _.each(temp, function(x){
          refineCrewType.push({
            crewType: x,
            crewTypeCode: x
          });
        });
      }


      vm.getRefineCrewType = function(){
        return refineCrewType;
      };


      vm.getDefaultRefineTrainer = function () {
        refineTrainer=[];
        refineTrainer.push({
          crewId:'ANY',
          crewName:null
        });
        return refineTrainer[0];
      }


      function setTrainersFormTrainingList() {
        refineTrainer = [];
        refineTrainer[0] = vm.getDefaultRefineTrainer();

        let trainers=[];

        _.each(trainingSchedule,function (item) {
          if(item.assignedTrainers&&item.assignedTrainers.length>0){
            let temp=item.assignedTrainers;
            for(let i=0;i<temp.length;i++){
              trainers.push(temp[i].crewName);
            }
          }
        })

        var sorted = _.sortBy(trainers, function(item){
          return item;
        });


        var temp =  _.uniq(sorted, true, function(i){
          return i;
        });

        _.each(temp, function(x){
          refineTrainer.push({
            crewId: x,
            crewName: x
          });
        });
      }


      vm.getRefineTrainers = function(){
        return refineTrainer;
      };

      vm.getDefaultRefineTrainee = function () {
        refineTrainee=[];
        refineTrainee.push({
          crewId:'ANY',
          crewName:null
        });
        return refineTrainee[0];
      }


      function setTraineesFormTrainingList() {
        refineTrainee = [];
        refineTrainee[0] = vm.getDefaultRefineTrainee();



        let trainees=[];
        _.each(trainingSchedule,function (item) {
          if(item.assignedTrainees&&item.assignedTrainees.length>0){
            let temp=item.assignedTrainees;
            for(let i=0;i<temp.length;i++){
              trainees.push(temp[i].crewName);
            }
          }
        })

        var sorted = _.sortBy(trainees, function(item){
          return item;
        });


        var temp =  _.uniq(sorted, true, function(i){
          return i;
        });

        _.each(temp, function(x){
          refineTrainee.push({
            crewId: x,
            crewName: x
          });
        });
      }


      vm.getRefineTrainee = function(){
        return refineTrainee;
      };



    }
}());
